// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#4D4F51","menuTextActive":"#FFA040","subMenuTextActive":"#f4f4f5","menuBg":"#ffffff","menuHover":"#FFF8F0","subMenuBg":"#ffffff","subMenuHover":"#FFF8F0"};